var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgWasher = function SvgWasher(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "svg110",
    width: 354,
    height: 354,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 354 354",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1096",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M38.424 73.148h281.73V32.224c0-13.681-11.188-24.864-24.876-24.864H63.298c-13.688 0-24.876 11.183-24.876 24.864zm127-38.663h27.375a7.465 7.465 0 0 1 7.498 7.495c0 4.045-3.451 7.376-7.498 7.376h-27.375c-4.047 0-7.498-3.331-7.498-7.376 0-4.164 3.451-7.495 7.498-7.495"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1098",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M182.44 112.88c51.061 0 92.6 41.4 92.6 92.554 0 51.036-41.539 92.554-92.6 92.554-51.18 0-92.6-41.519-92.6-92.554 0-51.155 41.42-92.554 92.6-92.554M38.42 84.091h281.73v238.29c0 13.681-11.188 24.983-24.876 24.983H63.294c-13.688 0-24.876-11.302-24.876-24.983z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path1100",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M182.68 145.12c21.305 0 40.111 11.064 50.823 27.719-15.235 22.246-13.569 44.017 0 65.549-10.831 16.536-29.518 27.6-50.823 27.6-33.326 0-60.345-27.124-60.345-60.434 0-33.429 27.018-60.434 60.345-60.434"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWasher);
export default ForwardRef;